
const LOGIN_REQUEST = 'LOGIN_REQUEST';

const LoginModel = function() {
    const name = 'login';
    return {
        name,
        actionTypes: {
            LOGIN_REQUEST
        },
        state: {
            isFetching : false
        },
        selectors: (state) => {
            const currentState = state[name];
            const selectors = {
                getFetching: () => currentState.isFetching
            };
            return selectors;
        },
        api: {

        },
        actions: {
            change: () => (dispatch, getState) => {
                dispatch({
                    type: LOGIN_REQUEST
                });
            }
        },
        reducers: {
            isFetching: (state=LoginModel.state.isFetching, action) => {
                if (action.type === LOGIN_REQUEST) {
                    return true;
                }
                return false;
            }
        }
    };
}();

export default LoginModel;


// WEBPACK FOOTER //
// ./src/models/LoginModel.js